var _circle, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarPatient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#979bb0",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.869 16)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    fill: "none",
    transform: "translate(10 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.132 2a6.184 6.184 0 1 0 6.184 6.184A6.191 6.191 0 0 0 14.132 2zm0 9.895a3.711 3.711 0 1 1 3.711-3.711 3.715 3.715 0 0 1-3.711 3.711zM25.263 25.5v-1.237a8.669 8.669 0 0 0-8.658-8.658h-4.947A8.668 8.668 0 0 0 3 24.263V25.5h2.474v-1.237a6.191 6.191 0 0 1 6.184-6.184h4.947a6.191 6.191 0 0 1 6.184 6.184V25.5z",
    transform: "translate(0)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: "2.5px",
    d: "M0 0L6.754 0",
    transform: "translate(26.623 40.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarPatient);
export default __webpack_public_path__ + "static/media/avatar-patient.39c3fb58.svg";
export { ForwardRef as ReactComponent };